import _ImageViewer from './image-viewer';

import './style/index.js';

export type { ImageViewerProps } from './image-viewer';
export * from './type';

export const ImageViewer = _ImageViewer;
export default ImageViewer;
